module.exports = __webpack_public_path__ + "static/media/TeamsAssets-Regular.c5a2112b.eot";